import { useTranslation, Trans } from 'react-i18next';

// Import components
import { Button } from 'components/elements/atoms/Button/Button';
import { ModalCloseButton } from '../components/ModalCloseButton';

// Import styles
import { AntModalStyled, ButtonContainer, StyledTitle, ModalContent, Description } from '../styles';

// Import types
import type { AntModalProps } from './AntNiceModal';

export const AntModal = ({
	namespace,
	title,
	description,
	context,
	confirmText,
	cancelText,
	visible,
	closable,
	onConfirm,
	onCancel,
	closeModal
}: AntModalProps & { visible: boolean; closeModal?: VoidFunction }) => {
	const { t } = useTranslation(namespace);

	return (
		<AntModalStyled visible={visible} closable={false} footer={null} centered>
			{closable && closeModal && <ModalCloseButton closeModal={closeModal} />}
			<ModalContent>
				<StyledTitle>
					<Trans ns={namespace} i18nKey={title} context={context} />
				</StyledTitle>
				{description && (
					<Description>
						<Trans ns={namespace} i18nKey={description.key} values={description.values} context={context} />
					</Description>
				)}
				<ButtonContainer>
					{confirmText && (
						<Button onClick={onConfirm} variant="primary" modifiers={['contained']}>
							{t(confirmText)}
						</Button>
					)}
					{cancelText && (
						<Button onClick={onCancel} variant="secondary" modifiers={['outlined']}>
							{t(cancelText)}
						</Button>
					)}
				</ButtonContainer>
			</ModalContent>
		</AntModalStyled>
	);
};
